import { Plug } from '../../components/Plug/Plug';
import './GalleryPage.scss';

export const GalleryPage = () => {
  return (
    <section className="gallery">
      <Plug />
    </section>
  );
};